module.exports = __webpack_public_path__ + "img/econoPro_promocional_final.612f12eb.png";